module.exports = [{"id":"new","title":"Самые новые","slug":"new"},{"id":"popular","title":"Популярные","slug":"popular"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/vdieoSortOptions.json
// module id = 3155
// module chunks = 16